import { ApiTileCarouselResult } from 'api/types/ApiTileCarouselResult';
import algoliaSearch from 'utils/algoliaSearch';
import { AreaOfFocus, VolopFunction } from 'utils/constants';
import getSearchConfig from 'utils/search/getSearchConfig';
import getSearchLocationOptions from 'utils/search/getSearchLocationOptions';
import { getVolopsSearchIndex } from 'utils/search/getVolopsSearchIndex';

export async function getRecommendedActions(
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>,
  queryOptions?: QueryOptions,
  options?: {
    volopFunction?: VolopFunction | null | undefined;
    areaOfFocus?: AreaOfFocus | null | undefined;
  },
) {
  const searchConfig = getSearchConfig();
  let locationOptions = {};

  if (searchLocation?.latitude && searchLocation?.longitude) {
    locationOptions = getSearchLocationOptions(
      'auto',
      searchLocation,
    ).locationOptions;
  }

  const filters = [
    'type:VOLOP',
    'source:IDEALIST',
    options?.volopFunction && `(functions:'${options.volopFunction}')`,
    options?.areaOfFocus && `(areasOfFocus: '${options.areaOfFocus}')`,
  ]
    .filter(Boolean)
    .join(' AND ');

  const options2: QueryOptions = {
    index: getVolopsSearchIndex(),
    filters,
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url',
    ],
    ...locationOptions,
    ...queryOptions,
  };

  return algoliaSearch<ApiTileCarouselResult>(searchConfig, '', options2).then(
    ({ hits }) => hits,
  );
}
